import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { PostContext } from 'shared-components/contexts/PostContext'
import styleUtils from 'shared-components/styles/util.module.css'
import {
  BasicStyledComponent,
  DSDataAttrs,
  DSPostShortSearch,
  DSPostShortWithAuthor,
} from 'shared-definitions/types'
import styles from './RecommendList.module.css'

interface PostCardRelatedProps extends BasicStyledComponent, DSDataAttrs {
  post: DSPostShortWithAuthor
  hideCategory?: boolean
  unresponsive?: boolean
}
interface RecommendListProps extends BasicStyledComponent {
  title: string | null
  itemsInList: number
  postCard: React.FC<PostCardRelatedProps>
  titleClassName?: string
  getRecommend: (
    postId: number,
    from: number,
    to: number,
    maxItems: number
  ) => Promise<DSPostShortSearch[]>
}

const RecommendList: React.VFC<RecommendListProps> = ({
  getRecommend,
  title,
  itemsInList,
  postCard: PostCardRelated,
  titleClassName,
  className,
}) => {
  const { postId } = PostContext.useContainer()
  const [items, setItems] = useState<DSPostShortWithAuthor[]>([])
  const [requestMade, setRequestMade] = useState(false)
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '710px' })

  useEffect(() => {
    if (!postId || !inView) {
      setItems(s => (s.length ? [] : s))
      return
    }

    void (async () => {
      const result = await getRecommend(postId, 0, itemsInList, 11)

      if (!result.length) {
        setRequestMade(true)
        return
      }
      setRequestMade(true)
      setItems(result)
    })()
  }, [postId, inView, getRecommend, itemsInList])

  return (
    <div
      ref={ref}
      className={clsx(styles.container, styleUtils.nc, className, {
        [styles.lazy]: !requestMade,
        [styles.empty]: requestMade && items.length === 0,
      })}
    >
      {title && <div className={clsx(styles.title, titleClassName)}>{title}</div>}
      {items.map((item, index) => (
        <PostCardRelated
          key={index}
          post={item}
          className={styles.item}
          data-sel="related-content-link"
        />
      ))}
    </div>
  )
}

export default RecommendList
